export default {
  //
}



// WEBPACK FOOTER //
// ./src/store/actions.js